import React, { Component } from 'react';
import { connect } from 'react-redux';
import CallAPI from '../commonComponents/AxiosHelper';
import LoadingComponent from '../commonComponents/LoadingComponent';
import Form from '../commonComponents/Form.v2';
import DropdownComponent from '../commonComponents/DropdownComponent';
import ModalComponent from '../commonComponents/ModalComponent';
import sanitizeHtml from 'sanitize-html';


class AuthIntegration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            authconfig: null,
            connectionArray: [],
            information: {},
            authObject: {},
            connectionForm: {
                "connectionName": {
                    "name": "connectionName", "label": "Connection Name", "type": "password", 'eyeIcon': true, "text_value": "", requiredFlag: true
                },
                "idProvider": {
                    "name": "type", "label": "Select Identity Provider", "type": "dropdown", "text_value": "3", "options": [
                        { "name": "Select Identity Provider", "value": "" },
                        { "name": "Keycloak", "value": "keycloak" },
                        { "name": "Okta", "value": "okta" },
                        { "name": "Azure AD", "value": "azure_ad" },
                        { "name": "AWS Cognito", "value": "awscognito" },
                    ], requiredFlag: true
                },

                "issuer": {
                    "name": "issuer", "label": "Issuer URL", "type": "password", 'eyeIcon': true, "text_value": "", requiredFlag: true
                },
                "clientId": {
                    "name": "clientId", "label": "Client ID", "type": "password", 'eyeIcon': true, "text_value": "", requiredFlag: true
                },
                "clientSecret": {
                    "name": "clientSecret", "label": "Client Secret", "type": "password", 'eyeIcon': true, "text_value": "", requiredFlag: true
                },
                "flow": {
                    "name": "flow", "label": "Authorization Flow", "type": "text", "type": "dropdown", "text_value": "", "options": [
                        { "name": "Select flow", "value": "" },
                        { "name": "Authorization Code", "value": "authorization_code" },
                        { "name": "Password", "value": "password" },
                    ], requiredFlag: true
                },
                "proxy": {
                    "name": "proxy", "label": "Proxy (Optional)", "type": "password", 'eyeIcon': true, "text_value": "", requiredFlag: false
                }
            },
            formChanges: {}

        }

        this.generateAuthForm = this.generateAuthForm.bind(this);
        this.handleAuthSubmit = this.handleAuthSubmit.bind(this);
        this.fetchAuthDetails = this.fetchAuthDetails.bind(this);
        this.handleConnectionChange = this.handleConnectionChange.bind(this);
        this.handleInsertAuth = this.handleInsertAuth.bind(this);
        this.handleFormChange = this.handleFormChange.bind(this);

    }

    componentWillMount() {
        this.fetchAuthDetails();
    }

    fetchAuthDetails() {
        this.setState({
            authconfig: null
        });
        let that = this, decodedResponse = null;
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            auth: "system"
        }
        CallAPI('get', '/app/oidc/getAuthDetail', null, params, 0, function (response) {
            if (response.status) {
                if (response.status == false) {
                    checkIfMaintenanceModeOn(response)
                }
                decodedResponse = JSON.parse(decodePassword(response.value))
                let connectionArrayKeys = Object.keys(JSON.parse(decodedResponse['information']));
                let connectionNames = connectionArrayKeys.map((element, i) => {
                    let innerArray = {};
                    innerArray.name = element;
                    innerArray.value = element;
                    return innerArray;
                });
                that.setState({
                    authconfig: JSON.parse(decodedResponse['authConfig']),
                    connectionArray: connectionNames,
                    information: JSON.parse(decodedResponse['information']),
                    authObject: decodedResponse
                })
            }
        })
    }

    handleAuthSubmit() {
        let that = this;

        // let authObject = JSON.parse(this.state.authconfig[0]['authConfig']);
        let authObject = this.state.authconfig;

        authObject['siteId'] = localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null;
        authObject['companyName'] = this.props.authData ? this.props.authData.companyName : null;

        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            auth: "system"
        };
        let checkValidity = true
        let authFormArray = jQuery(`#${this.state.authconfig.clientId}_form`).serializeArray();

        for (let i = 0; i < authFormArray.length; i++) {
            if (authFormArray[i]['name'] !== "connectionDropdown") {
                if (checkValidity && authFormArray[i]['name'] !== 'flow') {
                    checkValidity = /[+\=<>]+/.test(authFormArray[i]['value']) ? false : true
                }
                if (checkValidity) {
                    let endpointNames = ["urlAuthorize", "urlAccessToken", "urlResourceOwnerDetails"];

                    if (authObject['auth_endpoints'] == null && authObject['auth_endpoints'] == undefined) {
                        authObject['auth_endpoints'] = {};
                    }

                    if (authObject['query_params'] == null && authObject['query_params'] == undefined) {
                        authObject['query_params'] = {};
                    }

                    if (endpointNames.indexOf(authFormArray[i]['name']) !== -1) {
                        authObject['auth_endpoints'][authFormArray[i]['name']] = authFormArray[i]['value'];
                    }
                    else if (authFormArray[i]['name'] == "scopes") {
                        authObject['query_params']['scope'] = authFormArray[i]['value'];
                    }
                    else {
                        authObject[authFormArray[i]['name']] = authFormArray[i]['value'];
                    }
                }
            }
        };

        if (checkValidity == false) {
            alert("Improper details provided, please enter valid inputs!");
        } else {
            // let information = this.state.information;

            // information[authObject['connectionName']] = authObject;

            let data = {
                "issuer": authObject['issuer'],
                "authConfig": authObject,
                // "information": information
            }
            CallAPI('POST', '/app/oidc/updateAuthDetail', data, params, 0, function (response) {
                alert(response.information);
                that.fetchAuthDetails();
            })
        }
    }

    generateAuthForm(flag = 'default', valueFlag = false) {
        try {
            var formValueObj = {};
            var authState = this.state.authconfig;
            if (valueFlag == true && authState != null) {
                // let authconfig = JSON.parse(authState[0]['authConfig']);
                // formValueObj['issuer'] = authState['issuer'];
                let issuer = (this.state.formChanges.issuer == null || this.state.formChanges.issuer == undefined) ? authState['issuer'] : this.state.formChanges.issuer;

                let clientId = (this.state.formChanges.clientId == null || this.state.formChanges.clientId == undefined) ? authState['clientId'] : this.state.formChanges.clientId;

                let clientSecret = (this.state.formChanges.clientSecret == null || this.state.formChanges.clientSecret == undefined) ? authState['clientSecret'] : this.state.formChanges.clientSecret;

                let scopes = (this.state.formChanges.scopes == null || this.state.formChanges.scopes == undefined) ? authState['query_params']['scope'] : this.state.formChanges.scopes;

                let proxy = (this.state.formChanges.proxy == null || this.state.formChanges.proxy == undefined) ? authState['proxy'] : this.state.formChanges.proxy;

                if (proxy == undefined || proxy == undefined) {
                    proxy = '';
                }

                formValueObj['issuer'] = issuer;
                formValueObj['clientId'] = clientId;
                formValueObj['clientSecret'] = clientSecret;

                formValueObj['idProvider'] = authState['idProvider'];
                if (formValueObj['idProvider'] == "keycloak") {
                    formValueObj['idProvider'] = "Keycloak";
                }
                else if (formValueObj['idProvider'] == "okta") {
                    formValueObj['idProvider'] = "Okta";

                }
                else if (formValueObj['idProvider'] == "azure_ad") {
                    formValueObj['idProvider'] = "Azure AD";
                }
                else if (formValueObj['idProvider'] == "awscognito") {
                    formValueObj['idProvider'] = "AWS Cognito";
                }
                formValueObj['flow'] = authState['flow'];
                formValueObj['proxy'] = proxy;
                formValueObj['urlAuthorize'] = authState['auth_endpoints']['urlAuthorize'];
                formValueObj['urlAccessToken'] = authState['auth_endpoints']['urlAccessToken'];
                formValueObj['urlResourceOwnerDetails'] = authState['auth_endpoints']['urlResourceOwnerDetails'];
                formValueObj['scopes'] = scopes;
            }

            var settingFormData = {
                "idProvider": {
                    "name": "idProvider", "label": "Identity Provider", "type": "password", 'eyeIcon': true, encodeValue: true, "text_value": (formValueObj["idProvider"] != null && formValueObj["idProvider"] != undefined) ? formValueObj["idProvider"] : "", "disabled": true
                },

                "issuer": {
                    "name": "issuer", "label": "Issuer URL", "type": "password", 'eyeIcon': true, encodeValue: true, "text_value": (formValueObj["issuer"] != null && formValueObj["issuer"] != undefined) ? formValueObj["issuer"] : "", "disabled": true
                },
                "clientId": {
                    "name": "clientId", "label": "Client ID", "type": "password", 'eyeIcon': true, encodeValue: true, "text_value": (formValueObj["clientId"] != null && formValueObj["clientId"] != undefined) ? formValueObj["clientId"] : "", "disabled": true
                },
                "clientSecret": {
                    "name": "clientSecret", "label": "Client Secret", "type": "password", 'eyeIcon': true, encodeValue: true, "text_value": (formValueObj["clientSecret"] != null && formValueObj["clientSecret"] != undefined) ? formValueObj["clientSecret"] : "", "disabled": true
                },
                "flow": {
                    "name": "flow", "label": "Authorization Flow", "type": "text", "type": "dropdown", "text_value": (formValueObj["flow"] != null && formValueObj["flow"] != undefined) ? formValueObj["flow"] : "", "options": [
                        { "name": "Select flow", "value": "3" },
                        { "name": "Authorization Code", "value": "authorization_code" },
                        { "name": "Password", "value": "password" },
                    ],
                },
                // "proxy": {
                //     "name": "proxy", "label": "Proxy", "type": "text", "text_value": (formValueObj["proxy"] != null && formValueObj["proxy"] != undefined) ? formValueObj["proxy"] : "",
                // },
                "proxy": {
                    "name": "proxy", "label": "Proxy (Optional)", "type": "password", 'eyeIcon': true, encodeValue: true, "text_value": (formValueObj["proxy"] != null && formValueObj["proxy"] != undefined) ? formValueObj["proxy"] : "", "disabled": true
                },
                "urlAuthorize": {
                    "name": "urlAuthorize", "label": "Authorization URL (Auto-Generated)", "type": "password", 'eyeIcon': true, encodeValue: true, "text_value": (formValueObj["urlAuthorize"] != null && formValueObj["urlAuthorize"] != undefined) ? formValueObj["urlAuthorize"] : "", "disabled": true
                },
                "urlAccessToken": {
                    "name": "urlAccessToken", "label": "Token URL (Auto-Generated)", "type": "password", 'eyeIcon': true, encodeValue: true, "text_value": (formValueObj["urlAccessToken"] != null && formValueObj["urlAccessToken"] != undefined) ? formValueObj["urlAccessToken"] : "", "disabled": true
                },
                "urlResourceOwnerDetails": {
                    "name": "urlResourceOwnerDetails", "label": "User Resource Detail URL (Auto-Generated)", "type": "password", 'eyeIcon': true, encodeValue: true, "text_value": (formValueObj["urlResourceOwnerDetails"] != null && formValueObj["urlResourceOwnerDetails"] != undefined) ? formValueObj["urlResourceOwnerDetails"] : "", "disabled": true
                },
                "scopes": {
                    "name": "scopes", "label": "Scopes", "type": "password", 'eyeIcon': true, encodeValue: true, "text_value": (formValueObj["scopes"] != null && formValueObj["scopes"] != undefined) ? formValueObj["scopes"] : "", "disabled": true
                }
            };

            var formBody = <Form label_array={settingFormData} flag={flag} handleForm={this.handleFormChange} />;
            return formBody;

        }
        catch (e) {
            return "error";
        }
    }

    handleConnectionChange(e, reference) {
        let new_auth_config = this.state.information[e.target.value];
        this.setState({
            authconfig: new_auth_config
        })
    }

    handleInsertAuth(e) {
        let that = this;

        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            auth: "system"
        };

        let connFormData = {};

        let connFormArray = jQuery("#newAuth").serializeArray();
        let checkValidity = true;

        for (let i = 0; i < connFormArray.length; i++) {
            if (checkValidity && ['type', 'flow'].indexOf(connFormArray[i]['name']) == -1) {
                checkValidity = /[+\=<>]+/.test(connFormArray[i]['value']) ? false : true
            }
            checkValidity = checkValidity ? ((sanitizeHtml(connFormArray[i]['value']) == "" && connFormArray[i]['name'] !== "proxy") ? false : true) : false;
            checkValidity ? connFormData[connFormArray[i]['name']] = sanitizeHtml(connFormArray[i]['value']) : null
        }
        if (checkValidity === false) {
            alert("Improper details provided, please enter valid inputs!");
        } else {
            if (connFormData.type == "3") {
                alert("Please select connection type!");
            }
            else if (connFormData.connectionName == "" || connFormData.connectionName == null) {
                alert("Please provide connection name!");
            }
            else {
                connFormData.siteId = params.siteId;
                connFormData.companyName = this.props.authData ? this.props.authData.companyName : null;
                CallAPI('POST', '/app/oidc/putAuth', connFormData, params, 0, function (response) {
                    if (response.status) {
                        alert('Connection Added!');
                    }
                    jQuery("#authModal").modal('toggle');
                    that.fetchAuthDetails();
                })
            }
        }
        jQuery("#newAuth").trigger("reset");
        e.preventDefault();
    }

    handleFormChange(e) {
        let formChanges = this.state.formChanges;
        formChanges[e.target.name] = e.target.value;
        this.setState({
            formChanges: formChanges
        })
    }

    render() {

        var authFormbody = <LoadingComponent />;
        var auth_form_array = this.generateAuthForm();
        var id = 'form';

        var selectedAuthform = {};
        selectedAuthform.connectionName = {
            "name": "connectionName", "label": "Connection Name", "type": "text", "text_value": "", requiredFlag: true
        };
        selectedAuthform.idProvider = {
            "name": "type", "label": "Select Identity Provider", "type": "dropdown", "text_value": "3", "options": [
                { "name": "Select Identity Provider", "value": "" },
                { "name": "Keycloak", "value": "keycloak" },
                { "name": "Okta", "value": "okta" },
            ], requiredFlag: true
        };

        selectedAuthform.issuer = auth_form_array.issuer;
        selectedAuthform.clientId = auth_form_array.clientId;
        selectedAuthform.clientSecret = auth_form_array.clientSecret;
        selectedAuthform.flow = auth_form_array.flow;


        // var add_auth_form = <Form label_array={selectedAuthform} />;
        var add_auth_form = <Form label_array={this.state.connectionForm} />;
        var dropdownComponent = null;

        var modalConfig = {
            "addModal": {
                "form_name": "add_form", "form_id": "newAuth", "id": "authModal", "title": "Add Connection", "body": add_auth_form, "button_name": "Add and Update Connection", "action": "new", "display": true, buttonType: "submit"
            }
        };

        if (this.state.authconfig) {
            id = `${this.state.authconfig.clientId}_form`;
            authFormbody = this.generateAuthForm('value', true);
            // var auth_form = <Form label_array={authFormbody} />;
            dropdownComponent = (<><label htmlFor={`connConfig`}>{'Select Connection'}</label>
                <DropdownComponent class="form-control" name="connectionDropdown" id="connConfig" value={this.state.authconfig.connectionName} dropdownData={this.state.connectionArray} onChange={this.handleConnectionChange} /></>);
        }

        let formKey = this.state.authconfig ? `${this.state.authconfig.connectionName}_formvalue` : "formvalue";

        return (
            <div className="main-content d-flex justify-content-center align-item-center flex-column">
                <div className="w-100 d-flex justify-content-between alihn-items-center h-100">

                    <button data-bs-toggle="modal" data-bs-target="#authModal" className="btn btn-primary btn-sm">Add New Connection</button>
                    {/* Cancel Button */}
                    <button onClick={this.handleAuthSubmit} className="btn btn-primary btn-sm">Save Connection</button>
                </div>
                <div className="form-group wd-300">
                    <form autoComplete="off" onSubmit={this.onSubmit} key={formKey} id={id}>
                        <div className="mg-t-5 mg-b-10">
                            {dropdownComponent}
                        </div>
                        <div className="card" style={{ width: "102%", marginLeft: "-3px" }}>
                            <div className="card-body">
                                {authFormbody}
                            </div>
                        </div>
                    </form>
                </div>
                <ModalComponent modalConfig={modalConfig["addModal"]} formSubmit={this.handleInsertAuth} />
            </div>

        )
    }

}

function mapStateToProps(state) {
    return {
        dataSet: state.dataSet.dataSet,
        authData: state.dataSet.authData
    };
}

export default connect(mapStateToProps, null)(AuthIntegration);